import { get } from '../../../../service/ApiService';
import { axiosOtherTrackerInstance, axiosUserProfileInstance } from '../../../../configs/AxiosInstance';

// Read-only wrappers over the user-profile service's gut health tracker.
// FlexBoard never calls the /modify endpoints: coaches can see a client's
// logs but not change them.

const BASE = '/gut-health-tracker';

function query(params) {
  return Object.entries(params)
    .filter(([, v]) => v != null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
}

/** Raw rows in [startDate, endDate] (inclusive; the server caps the range under 366 days). */
const rows = (path) => (userId, startDate, endDate) =>
  get(`${BASE}${path}?${query({ user_id: userId, start_date: startDate, end_date: endDate })}`, {
    instance: axiosUserProfileInstance,
  }).then((res) => (Array.isArray(res?.data) ? res.data : []));

/** `{ date, symptom_id, symptom_name, symptom_score }` per rated symptom (1–5), plus "No Gut Symptom" rows. */
export const fetchGutSymptoms = rows('/symptoms');

/** One row per bowel movement: `{ date (local datetime), bristol_stool_id, bristol_stool_name, urgency_rating, strain_rating, evacuation_complete }`. */
export const fetchBowelLogs = rows('/bowel');

/**
 * Water tracked per day in [startDate, endDate], from other-trackers — the
 * endpoint `fetchWaterSummary` (service/userService) reads, with an explicit
 * date range instead of its D/W/M one. One row per tracked day:
 * `{ date, quantity_types: [{ total_actual_quantity, total_plan_water_quantity }] }`.
 */
export const fetchWaterTracking = (eventTypeId, clientId, startDate, endDate) =>
  get(
    `/fetch-daily-water-tracking-summary?event_type_id=${encodeURIComponent(eventTypeId)}&client_id=${encodeURIComponent(clientId)}` +
      `&start_date=${startDate}T00:00:00&end_date=${endDate}T23:59:59`,
    { instance: axiosOtherTrackerInstance }
  ).then((res) => (Array.isArray(res?.data) ? res.data : []));
